import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '@/store';

export interface CheckoutReturnFile {
  file: File | null;
  fileName: string;
  extension: string;
  toolType?: string;
  originEntryPoint?: string;
}

interface CheckoutReturnState {
  lastCheckoutFile: CheckoutReturnFile | null;
  pendingProceedPopup: boolean;
}

const initialState: CheckoutReturnState = {
  lastCheckoutFile: null,
  pendingProceedPopup: false,
};

const checkoutReturnSlice = createSlice({
  name: 'checkoutReturn',
  initialState,
  reducers: {
    setLastCheckoutFile: (state, action: PayloadAction<CheckoutReturnFile>) => {
      state.lastCheckoutFile = action.payload;
      state.pendingProceedPopup = false;
    },
    requestProceedPopup: (state) => {
      state.pendingProceedPopup = Boolean(state.lastCheckoutFile);
    },
    consumeProceedPopup: (state) => {
      state.pendingProceedPopup = false;
    },
  },
});

export const { setLastCheckoutFile, requestProceedPopup, consumeProceedPopup } =
  checkoutReturnSlice.actions;

export const selectLastCheckoutFile = (state: RootState) =>
  state.checkoutReturn.lastCheckoutFile;
export const selectPendingProceedPopup = (state: RootState) =>
  state.checkoutReturn.pendingProceedPopup;

export default checkoutReturnSlice.reducer;
